import { Dispatch, SetStateAction } from "react";
import api from "../../../utils/api";
import { DELETE_LOOKUP_ITEM } from "../../../utils/endpoints";
import { auxiliaresLookUps } from "../data/AuxiliaresLookUps";
import { fetchAuxiliaresData } from "../data/fetchAuxiliaresData";

export const handleDeleteItem = async (
  id: string,
  table: string,
  setDataTable: Dispatch<SetStateAction<any[]>>,
  setOriginalDataTable: Dispatch<SetStateAction<any[]>>,
  addToast: (options: {
    title: string;
    description: string;
    status: "success" | "error";
  }) => void,
  setIsAlertOpen: (isOpen: boolean) => void,
  setIsOpen: (isOpen: boolean) => void,
  setIsLoaded: Dispatch<SetStateAction<boolean>>,
) => {
  setIsLoaded(false);
  const tableIndex = +table - 1;
  const entityType = auxiliaresLookUps[tableIndex].entityName;

  try {
    const response = await api.delete(DELETE_LOOKUP_ITEM, {
      data: { entityType, id },
    });

    if (response.status === 200) {
      await fetchAuxiliaresData(tableIndex, setDataTable, setOriginalDataTable);
      addToast({
        title: "Sucesso",
        description: "Item eliminado",
        status: "success",
      });
      setIsAlertOpen(false);
      setIsOpen(false);
    } else {
      throw new Error();
    }
  } catch (error) {
    console.error("API Error:", error);
    addToast({
      title: "Erro",
      description: "Ocorreu um erro ao eliminar o item",
      status: "error",
    });
  }
  setIsLoaded(true);
};
